<template>
  <div>
    <nav class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="goBack"></a>
      <h1 class="title">发票寄送地址</h1>
    </nav>
    <div class="content">
      <div class="list-block media-list">
        <ul>
          <li v-for="(address, index) in invoiceInfo" :id="index">
            <router-link :to="{ name: 'invoiceAddressModify', query: { num:  index, from: from  }, params:{order: $route.params.order}  }" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{address.consignee}}</div>
                  <div class="item-after" v-if="address.isDefault == 1">默认地址</div>
                </div>
                <div class="item-subtitle">{{address.expressMobile}}</div>
                <div class="item-text">{{address.expressAddress}}</div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div id="button-div" class="col-100">
            <router-link :to="{name: 'addInvoiceAddress', query: {from: from}, params:{order: $route.params.order}}" style="width: 100%;" :disabled="count>2" :class="{'disabled':count>2}" class="button button-big button-fill">
              新增寄送地址
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import emkt from './../../../emkt'

  export default {
    created () {
      this.getData()
    },
    mounted () {
    },
    data () {
      return {
        invoiceInfo: [],
        from: ''
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      'count': function () {
        return this.sessionInfo.invoiceAddress.length
      }
    },
    watch: {
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
        vm.from = from.query.from ? from.query.from : from.name
      })
    },
    methods: {
      ...mapMutations([
        'INVOICE_ADDRESS'
      ]),
      getData () {
        let _this = this
        _this.gcapi('gcwwwifc/getAddressInfoByCustomerNo?customerNo=' + this.sessionInfo.customerInfo.customerNo).then((response) => {
          let result = response.body.result.filter(r => r.addressStatus !== emkt.ADDRESS_STATUS.ADDRESS_STATUS_INVALID)
          _this.invoiceInfo = result
          _this.INVOICE_ADDRESS(result)
        })
      },
      goBack () {
        // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
        if (this.from === 'orderContentConfirm') {
          this.$router.replace({name: 'orderContentConfirm'})
        } else if (this.from === 'orderContent') {
          this.$router.replace({name: 'orderContent', params: {order: this.$route.params.order}})
        } else {
          this.$router.push({name: 'me'})
        }
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceAddress.vue?3e12418a